export const MODAL_OVERLAY_DEFAULT_OPACITY = 0.75 as number;
